<template>
  <el-checkbox-group
    class="ui-checkbox-group"
    :value="value"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <slot />
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'UiCheckboxGroup',
  inheritAttrs: false,
  props: {
    value: { type: Array, default: () => [] }
  },
  computed: {
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      delete listeners.change
      return listeners
    }
  }
}
</script>

<style lang="scss">
.ui-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ui-space-sm) var(--ui-space-md);
}

.ui-checkbox-group > .ui-checkbox,
.ui-checkbox-group > .el-checkbox {
  margin-right: 0;
}
</style>
